const DISPUTES_TABLE_HEADERS = [
  {
    name: 'Customer',
    column: 'customer_email'
  },
  {
    name: 'Description',
    column: 'description'
  },
  {
    name: 'Amount',
    column: 'amount_currency'
  },
  {
    name: 'Reference',
    column: 'reference'
  },
  {
    name: 'Date',
    column: 'created_at',
    filter: 'date'
  },
  {
    name: 'Dispute Type',
    column: 'dispute_type'
  },
  {
    name: 'Status',
    column: 'status'
  }
];

const ADMIN_DISPUTES_TABLE_HEADERS = [
  {
    name: 'Merchant',
    column: 'merchant_name'
  },
  {
    name: 'Customer',
    column: 'customer_email'
  },
  {
    name: 'Wallet Address',
    column: 'wallet_address'
  },
  {
    name: 'Amount Paid',
    column: 'amount_currency'
  },
  {
    name: 'Refund Amount',
    column: 'refund_amount_currency'
  },
  {
    name: 'Reference',
    column: 'reference'
  },
  {
    name: 'Date',
    column: 'created_at',
    filter: 'date'
  },
  {
    name: 'Dispute Type',
    column: 'dispute_type'
  },
  {
    name: 'Status',
    column: 'status'
  }
];

const DISPUTES_STATUSES = [
  {
    label: 'All Disputes',
    value: ''
  },
  {
    label: 'Pending',
    value: 'PENDING'
  },
  {
    label: 'Dispute',
    value: 'DISPUTE'
  },
  {
    label: 'Accepted',
    value: 'ALLOWED'
  },
  {
    label: 'Refund Successful',
    value: 'REFUND_SUCCESSFUL'
  },
  {
    label: 'Refund Failed',
    value: 'REFUND_FAILED'
  }
];
export { ADMIN_DISPUTES_TABLE_HEADERS, DISPUTES_STATUSES, DISPUTES_TABLE_HEADERS };
